<script setup lang="ts">
defineProps<{
  infos: {
    prerequisites: string[]
    admission: string[]
    opportunities: string[]
    environments: string[]
  }
}>()
</script>

<template>
  <section class="py-20 bg-background border-t border-oxo-border transition-colors duration-300">
    <div class="container mx-auto px-6">
      <div class="flex flex-wrap justify-center gap-12 lg:gap-8">
        <!-- Prerequisites -->
        <div class="grow basis-[250px] max-w-[400px]">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-lg bg-oxo-red/10 text-oxo-red flex items-center justify-center text-xl">
              <i class="fas fa-list-ul" aria-hidden="true"></i>
            </div>
            <h2 class="font-display font-bold text-xl text-foreground">Prérequis</h2>
          </div>
          <ul class="space-y-3">
            <li v-for="(item, index) in infos.prerequisites" :key="index" class="flex items-start gap-3 text-foreground-dim text-sm">
              <span class="w-1.5 h-1.5 rounded-full bg-oxo-red mt-2 shrink-0"></span>
              {{ item }}
            </li>
          </ul>
        </div>

        <!-- Admission -->
        <div class="grow basis-[250px] max-w-[400px]">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-lg bg-oxo-yellow/10 text-oxo-yellow flex items-center justify-center text-xl">
              <i class="fas fa-user-check" aria-hidden="true"></i>
            </div>
            <h2 class="font-display font-bold text-xl text-foreground">Admission</h2>
          </div>
          <ul class="space-y-3">
            <li v-for="(item, index) in infos.admission" :key="index" class="flex items-start gap-3 text-foreground-dim text-sm">
              <span class="w-1.5 h-1.5 rounded-full bg-oxo-yellow mt-2 shrink-0"></span>
              {{ item }}
            </li>
          </ul>
        </div>

        <!-- Opportunities (Jobs) -->
        <div class="grow basis-[250px] max-w-[400px]">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-lg bg-green-500/10 text-green-500 flex items-center justify-center text-xl">
              <i class="fas fa-briefcase" aria-hidden="true"></i>
            </div>
            <h2 class="font-display font-bold text-xl text-foreground">Métiers visés</h2>
          </div>
          <ul class="space-y-3">
            <li v-for="(item, index) in infos.opportunities" :key="index" class="flex items-start gap-3 text-foreground-dim text-sm">
              <span class="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 shrink-0"></span>
              {{ item }}
            </li>
          </ul>
        </div>

        <!-- Environments -->
        <div class="grow basis-[250px] max-w-[400px]">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-lg bg-purple-500/10 text-purple-500 flex items-center justify-center text-xl">
              <i class="fas fa-building" aria-hidden="true"></i>
            </div>
            <h2 class="font-display font-bold text-xl text-foreground">Environnements</h2>
          </div>
          <ul class="space-y-3">
            <li v-for="(item, index) in infos.environments" :key="index" class="flex items-start gap-3 text-foreground-dim text-sm">
              <span class="w-1.5 h-1.5 rounded-full bg-purple-500 mt-2 shrink-0"></span>
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
